export const cancel = 'Cancel';

export const skipReasons = [
  'Urgent Housing Need',
  'Medical Necessity',
  'Income Targeting',
  'Preferences',
  'Other - See Notes',
];
